module.exports = __webpack_public_path__ + "img/actshop2.c6351284.jpg";